// extracted by mini-css-extract-plugin
export default {"chat-placeholder":"deal_chat-placeholder__uremZ"};